import React, { useState } from 'react'
import { ConfiaCarContainer } from 'src/components/confiacar/container'
import { ConfiaCarRow } from 'src/components/confiacar/Row'
import { ConfiaCarCol } from 'src/components/confiacar/Col'
import { ConfiaCarCardGroup } from 'src/components/confiacar/Card/CardGroup'
import { ConfiaCarCard, ConfiaCarCardBody } from 'src/components/confiacar/Card'
import {
  ConfiaCarForm,
  ConfiaCarInput,
  ConfiaCarInputGroup,
  ConfiaCarInputGroupText,
} from 'src/components/confiacar/Form'
import { ConfiaCarButton } from 'src/components/confiacar/Button'
import { useAuth } from 'src/contexts/authContext'
import { MdMailOutline } from 'react-icons/md'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const { forgotPassword } = useAuth()

  const handleEmail = (payload) => {
    setEmail(payload)
  }

  const requestPasswordRecovery = async () => {
    await forgotPassword(email)
  }

  return (
    <div className="bg-primary min-vh-100 d-flex flex-row align-items-center">
      <ConfiaCarContainer>
        <ConfiaCarRow className="justify-content-center">
          <ConfiaCarCol md={8}>
            <ConfiaCarCardGroup>
              <ConfiaCarCard className="p-4">
                <ConfiaCarCardBody>
                  <ConfiaCarForm>
                    <h1>Esqueci minha senha</h1>
                    <p className="text-medium-emphasis">
                      Informe o e-mail ou cpf cadastrado para recuperar sua seha
                    </p>
                    <ConfiaCarInputGroup className="mb-3">
                      <ConfiaCarInputGroupText>
                        <MdMailOutline />
                      </ConfiaCarInputGroupText>
                      <ConfiaCarInput
                        id="email"
                        placeholder="E-mail / CPF"
                        autoComplete="email"
                        value={email}
                        onChange={(event) => handleEmail(event.target.value)}
                      />
                    </ConfiaCarInputGroup>
                    <ConfiaCarRow>
                      <ConfiaCarCol>
                        <div className="d-grid gap-2">
                          <ConfiaCarButton onClick={() => requestPasswordRecovery()}>
                            Recuperar senha
                          </ConfiaCarButton>
                        </div>
                      </ConfiaCarCol>
                    </ConfiaCarRow>
                  </ConfiaCarForm>
                </ConfiaCarCardBody>
              </ConfiaCarCard>
            </ConfiaCarCardGroup>
          </ConfiaCarCol>
        </ConfiaCarRow>
      </ConfiaCarContainer>
    </div>
  )
}

export default ForgotPassword
